var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
var SvgKarton = function (props) { return (_jsx("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", fill: "none", viewBox: "0 0 100 100" }, props, { children: _jsx("path", { fill: "currentColor", d: "m30.817 61.527-.8 7.637a3.359 3.359 0 0 0 2.966 3.674l29.816 3.14c.122.01.233.022.355.022.755 0 1.488-.256 2.088-.746a3.354 3.354 0 0 0 1.221-2.249l4.52-43.174a3.34 3.34 0 0 0-2.965-3.674l-15.89-1.67-2.222-.234-11.704-1.236a3.328 3.328 0 0 0-2.443.724 3.353 3.353 0 0 0-1.222 2.249L31.051 59.3l-.234 2.227ZM64.253 72.77a1.1 1.1 0 0 1-.41.746c-.234.19-.523.267-.811.245l-29.816-3.14a1.112 1.112 0 0 1-.988-1.224l4.52-43.174c.033-.3.177-.557.399-.746.233-.19.522-.279.81-.245l29.816 3.14c.3.033.556.177.745.4.188.234.277.523.244.813l-4.53 43.185h.021Z" }) }))); };
export default SvgKarton;
